import React, {useState, useEffect, useRef} from 'react';
import BannerCFDI from '../TTCFDI/BannerCFDI';
import DescripcionCFDI from '../TTCFDI/DescripcionCFDI';
import FichaTecnicaCFDI from '../TTCFDI/FichaTecnicaCFDI';
import DescripcionCFDIFondo from '../TTCFDI/DescripcionCFDIFondo';

export default function TTCFDI(props){

    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);


    return(<>
    <BannerCFDI/>
    <div style={{height: '20px'}}></div>
    <DescripcionCFDI/>
    <div style={{height: '20px'}}></div>
    <FichaTecnicaCFDI/>
    <div style={{height: '20px'}}></div>
    <DescripcionCFDIFondo/>
    <div style={{height: '20px'}}></div>
    </>)
}